import React from 'react'

import DataTable from '../components/DataTable'

const Unfulfilled = () => {
  return (
    <DataTable url='shipments' title="Shipments" />
  )
}
export default Unfulfilled
